import { stringify } from 'qs';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IReportsQueryParams, IReportsResponse } from '../types';

export const getReportsQueryKey = 'getReports';

const getReports = async ({
    pageSize, currentPage, orgId, configured_filters, sorting, searchValue,
}: IReportsQueryParams): Promise<IReportsResponse> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.ORG_REPORTS(orgId)}`, {
        params: {
            page: currentPage,
            page_size: pageSize,
            configured_filters: JSON.stringify(configured_filters),
            search_value: searchValue,
            ...sorting,
        },
        paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
    });
    return response.data;
};

export const useGetReports = ({
    pageSize, currentPage, orgId, sorting, configured_filters, searchValue,
}: IReportsQueryParams) => useQuery({
    queryKey: [getReportsQueryKey, orgId, currentPage, pageSize, sorting, configured_filters, searchValue],
    queryFn: () => getReports({
        pageSize, currentPage, orgId, sorting, configured_filters, searchValue,
    }),
    staleTime: 5000,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
});

export default useGetReports;
